import TabPane from './TabPane';

TabPane.install = function(Vue) {
    Vue.component(TabPane.name, TabPane);
};

export default TabPane;